/* eslint-disable */

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Modal, Col, Row, Button, Icon, Input} from 'antd'
import styles from './index.less'
import Sortable from 'sortablejs'
import QueueAnim from 'rc-queue-anim'
import {  sortNavigationByGroup } from '../../reducers/navigation'


const commonUrl = [
  {
    group: '常用',
    icon: 'http://www.zt-express.com/img/base1/often.png',
    data: [
      {name: '安全中心', url: '',},
      {name: '中通论坛', url: '',},
      {name: 'OA', url: '',},
      {name: '中通优选', url: '',},
      {name: '中通官网', url: '',},
      {name: '吉信', url: '',},
      {name: '百度', url: '',},
      {name: 'Facebook', url: '',},
    ]
  },
  {
    group: '网点',
    icon: 'http://www.zt-express.com/img/base1/often.png',
    data: [
      {name: '运单管理', url: '',},
      {name: '手机短信系统', url: '',},
      {name: '签收管理', url: '',},
      {name: '问题件管理', url: '',},
      {name: '扫描管理', url: '',},
      {name: '物料系统', url: '',},
      {name: '快件跟踪', url: '',},
    ]
  },
];

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? '移动' : 'PC'

@connect(({session,navigation})=>({
  session,
  navigation
}), dispatch => bindActionCreators({ sortNavigationByGroup }, dispatch))
export default class Navigation extends Component{
  constructor(props){
    super(props);
    this.state = {
      dataSource: [],
      prevDataSource: [],
      editAble: false,
      showEditModal: false,
      groupUrlList: [],
      newUrl: '',
      newUrlName: '',
      groupCommonUrlList: [],
    };
    this.sortList = [];

  }

  componentWillMount(){
    // this.setState({dataSource: data});
    // this.props.getNavigationList()


  }


  componentDidUpdate(prevProps, prevState){
    const {dataSource, prevDataSource, editAble} = this.state;
    if (prevState.editAble !== this.state.editAble){
      this.sortList.forEach(item => {
        item.option("disabled", !this.state.editAble)
      })
    }
    if (!prevState.editAble && this.state.editAble){
      this.setState({
        prevDataSource: this.state.dataSource
      })
    }
    if (prevState.editAble && !this.state.editAble){
      for (let i = 0; i < dataSource.length; i++){
        for (let j = 0; j< dataSource[i].Apps.length; j ++){
          if (dataSource[i].Apps[j].id !== prevDataSource[i].Apps[j].id){
            this.props.sortNavigationByGroup({
              category_id: dataSource[i].id,
              refers: dataSource[i].Apps.map(item => item.id).join(','),
            });
            break;
          }
        }
      }
    }
  }

  componentWillReceiveProps(nextProps){
    if (this.props.navigation.navigationList.length !== nextProps.navigation.navigationList.length){
      this.setState({
        dataSource: nextProps.navigation.navigationList
      })
    }
  }



  sortDecorator = ( component) => {
    let index = component.getAttribute('data-index');

    if (component) {
      let options = {
        disabled: true,
        handle: '.handle',
        onUpdate: (e) => {
          console.log(e, index);
          const dataSource = JSON.parse(JSON.stringify(this.state.dataSource));
          if(dataSource[index] && dataSource[index].Apps) {
            let oldData = dataSource[index].Apps.splice(e.oldIndex, 1)[0];
            dataSource[index].Apps.splice(e.newIndex, 0, oldData);
            this.setState({
              dataSource
            });
            console.log('dataSource -->>', dataSource);
          } else {
            console.log('无效 index', dataSource, index);
          }
        }
      };
      let sortable = new Sortable(component, options);
      this.sortList.push(sortable)
    }

  };


  onEditGroup(groupData){

    let groupCommonUrlList = commonUrl.find(item => item.group === groupData.group).data;

    this.setState({
      showEditModal: true,
      groupUrlList: groupData.data,
      groupCommonUrlList,
    })
  }

  onClose(){
    this.setState({
      showEditModal: false,
      newUrl: '',
      newUrlName: '',
    })
  }


  onAddUrl(){
    const { newUrl, newUrlName, groupUrlList } = this.state;
    if (!newUrl || !newUrlName ) return;

    let newGroupList = [...groupUrlList, {name: newUrlName, url: newUrl}]

    this.setState({
      groupUrlList: newGroupList
    })

  }

  onRemoveUrl(urlItem){
    const groupUrlList = [...this.state.groupUrlList]
    let idx = groupUrlList.findIndex(item => item.url === urlItem.url && item.name === urlItem.name);
    console.log('idx', idx)
    idx !== -1 && groupUrlList.splice(idx,1);
    this.setState({
      groupUrlList
    })
  }
  // 上传百度统计
  zcatStatistics(name,item){
    zcat.logMetric(item.name, 1);
    // const userinfo = this.props.session && this.props.session.userinfo
    // _hmt.push(['_trackEvent', isMobile ,  item.name + '/' + name , userinfo.dept_name + '/'+ userinfo.fullname,])
  }


  render(){
    const { editAble, showEditModal, groupUrlList, groupCommonUrlList, newUrlName, newUrl } = this.state;
    const { navigationList } = this.props.navigation;

    if (navigationList.length === 0) return '';


    return(
      <div className={styles.container + ' clearfix ' + (editAble ? styles.edit_list : '')}>
        <Button className={styles.edit_btn} size="small" icon={ editAble ? 'rollback' : 'setting'} onClick={()=>{this.setState({editAble:!editAble})}}>{editAble?'返回':'编辑'}</Button>
        <QueueAnim style={{float: "left"}}>
          {
            navigationList.map((item, index) => (
              <div key={index} className={styles.group_container + ' clearfix'}>
                <div className={styles.group_name}>
                  <img src={item.icon} alt=""/>
                  <h2>{item.name}</h2>
                </div>
                <ul data-index={index} ref={ this.sortDecorator } className={styles.url_list}>
                  {
                    item.Apps.map((i, index) => (
                      <li key={index} className="handle" onClick={this.zcatStatistics.bind(this,item.name,i)}>
                        <a href={i.url} target="_blank">{i.name}</a>
                      </li>
                    ))
                  }
                  {/*<li className={styles.handle_add} style={{visibility: editAble ? 'hidden': 'visible'}}>*/}
                    {/*<a onClick={ this.onEditGroup.bind(this, item) }><Icon type="plus-circle" /> 添加</a>*/}
                  {/*</li>*/}
                </ul>
              </div>
            ))
          }
        </QueueAnim>


        <Modal
          title={"添加网址"}
          footer={false}
          width={800}
          visible={showEditModal}
          onCancel={ ::this.onClose }
        >
          <div className={styles.modal_container}>
            <div className={styles.my_url_Content + ' clearfix'}>
              <h2>我添加的网址:</h2>
              <ul className={styles.my_url_list}>
                {
                  groupUrlList.map((item, index) => (
                    <li key={index}>
                      <span>{item.name + ' '}</span>
                      <Icon className={styles.close_icon} onClick={ this.onRemoveUrl.bind(this, item)} type="close-circle" />
                    </li>
                  ))
                }
              </ul>
            </div>
            <Row gutter={15}>
              <Col span={6}>
                <Input placeholder="名称" value={newUrlName} onChange={(e)=> this.setState({ newUrlName:e.target.value})} />
              </Col>
              <Col span={14}>
                <Input placeholder="网址" value={newUrl} onChange={(e)=> this.setState({ newUrl:e.target.value})}/>
              </Col>
              <Col span={4}>
                <Button type="primary" onClick={ ::this.onAddUrl }>添加网址</Button>
              </Col>
            </Row>
            <div className={styles.common_list}>
              <h2>常用地址:</h2>
              <ul className="clearfix">
                {
                  groupCommonUrlList.map((item, index) => {
                    let idx = groupUrlList.findIndex(i => i.name === item.name);
                    return(
                        <li key={index} onClick={() => {
                          if (idx === -1){
                            let newGroupUrlList = [...groupUrlList, item];
                            this.setState({groupUrlList: newGroupUrlList})
                          } else {
                            let newGroupUrlList = [...groupUrlList];
                            newGroupUrlList.splice(idx, 1);
                            this.setState({groupUrlList: newGroupUrlList})
                          }
                        }}>
                          {
                             idx > -1 ?
                              <Icon type="check" style={{color: '#FF8400'}}/>
                              :
                              <Icon type="plus" style={{color: '#1078ca', fontWeight: 'bold'}}/>
                          }

                          <span>{item.name}</span>
                        </li>
                      )

                  })
                }
              </ul>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Navigation/index.js